import React, { useEffect, useState, useContext } from "react";
import notificationsService from "../../services/api/notifications-service";
import { useHistory } from "react-router-dom";
import ProjectContext from '../../ProjectContext';
import Pagination from "react-js-pagination";
import Moment from 'react-moment';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faTrashRestoreAlt } from '@fortawesome/free-solid-svg-icons'
import ReactDatetime from "react-datetime";
import moment from "moment";
import './notificaton.css';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";


const List = (props) => {
  const projectDetails = useContext(ProjectContext);
  const history = new useHistory();

  if (projectDetails.id == '') {
    history.push("/project/allprojects");
  }
  const projectId = projectDetails.id;
  const [notifications, setNotifications] = useState(false);
  const [totalNotifications, setTotalNotifications] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [renderComponent, setRenderComponent] = useState(false);
  const [showPopup, setShowPopup] = useState({ alert: null });
  const [reloadComponent, setReloadComponent] = useState(0);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleNotificationId, setRescheduleNotificationId] = useState(null);
  const [rescheduleTime, setRescheduleTime] = useState(null);
  const [rescheduleLoader, setRescheduleLoader] = useState(false);
  const [rescheduleError, setRescheduleError] = useState('');
  const records = 10;


  useEffect(() => {
    (async () => {
      let notificationsData = await notificationsService.getProjectNotifications(projectId, activePage, records);
      if (notificationsData.status) {
        console.log("notificationsData", notificationsData)
        setNotifications(notificationsData.data.notificationList);
        setTotalNotifications(notificationsData.data.count);
      }
      // let totalNotificationsData = await notificationsService.getProjectTotalNotifications(projectId);
      // if(totalNotificationsData.status && totalNotificationsData.data){
      //     setTotalNotifications(totalNotificationsData.data.count);
      // }
      setRenderComponent(true);
    })();
  }, [reloadComponent, activePage]);

  const handlePageChange = (pageNumber) => {
    console.log(pageNumber);
    setActivePage(pageNumber);
  }

  const openRescheduleModal = (notificationId, scheduledAt) => {
    setRescheduleNotificationId(notificationId);
    setRescheduleTime(scheduledAt ? moment(scheduledAt) : null);
    setRescheduleError('');
    setShowRescheduleModal(true);
  }

  const handleRescheduleConfirm = async () => {
    if (!rescheduleTime) {
      setRescheduleError('Please select a new schedule time.');
      return;
    }
    setRescheduleLoader(true);
    setRescheduleError('');
    try {
      const response = await notificationsService.rescheduleNotification({
        notificationId: rescheduleNotificationId,
        scheduleTime: moment.isMoment(rescheduleTime) ? rescheduleTime.toISOString() : rescheduleTime,
      });
      if (response && response.status) {
        setShowRescheduleModal(false);
        setReloadComponent(prev => prev + 1);
      } else {
        setRescheduleError(response?.error?.message || 'Failed to reschedule. Please try again.');
      }
    } catch (err) {
      setRescheduleError('Failed to reschedule. Please try again.');
    }
    setRescheduleLoader(false);
  }

  const disablePastDates = (current) => current.isAfter(moment());


  let notificationElements = [];
  let firstRecord = 0;
  let lastRecord = 0;
  if (!notifications || !notifications.length) {
    if (!renderComponent) {
      notificationElements.push(
        <td colSpan="9" className="text-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </td>
      );
    } else {
      notificationElements.push(
        <td colSpan="9" className="text-center">
          <CardTitle tag="h4">No Notifications Found</CardTitle>
        </td>
      );
    }
  } else {
    let i = 1;
    notifications.forEach(function (notificationDetails) {
      let className = '';
      if (notificationDetails.message_type == 'article_promotion') {
        className = 'border-danger1';
      } else {
        className = 'border-primary1';
      }
      if (i == 1) {
        firstRecord = (activePage - 1) * records + i;
      }
      const isScheduled = notificationDetails.scheduled == true;
      const isPendingScheduled = isScheduled && !notificationDetails.delivery_status;
      notificationElements.push(
        <tr className={className}>
          <td className="text-left">
            {notificationDetails.message}
          </td>
          <td className="text-left">
            <strong>{notificationDetails.platform}</strong>
          </td>
          <td className="text-center">
            {isScheduled ? (
              <div>
                <div><strong>Yes</strong></div>
                <Moment format="DD MMM YYYY hh:mm:ss a">{notificationDetails.scheduled_at}</Moment>
                {isPendingScheduled && (
                  <div>
                    <span
                      style={{ fontSize: '11px', color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                      onClick={() => openRescheduleModal(notificationDetails.id, notificationDetails.scheduled_at)}
                    >
                      Reschedule
                    </span>
                  </div>
                )}
              </div>
            ) : <strong>No</strong>}
          </td>
          <td className="text-left">
            {notificationDetails.message_type}
          </td>
          <td className="text-left">
            {notificationDetails.send_medium && notificationDetails.send_medium == 1 ? "Auto" : "Manual"}
          </td>
          <td className="text-left">
            <Moment format="DD MMM YYYY hh:mm:ss a">{notificationDetails.sent_on}</Moment>
          </td>
          <td className="text-left">
            <strong>{notificationDetails.delivery_status ? notificationDetails.delivery_status : (isScheduled ? "Schedule" : "success")}</strong>
          </td>
          <td className="text-center">
            {notificationDetails.reason ? notificationDetails.reason : "-"}
          </td>
          <td className="text-left">
            <div>
              {notificationDetails.message_service ? notificationDetails.message_service : "firebase"}
            </div>
          </td>
        </tr>
      )
      if (i == notifications.length) {
        lastRecord = (activePage - 1) * records + i;
      }
      i++;
      if (i == notifications.length) {
        lastRecord = (activePage - 1) * records + i;
      }
    })
  }


  return (
    <div className="content">
      <Row>
        <Col className="ml-auto mr-auto" md="12">
          <Card className="card-signup text-start dp-box">
            <CardHeader>
              <CardTitle tag="h4" className="heding_dsh_h4">
                Recent Notifications
              </CardTitle>

            </CardHeader>
            <CardBody>
              <Table responsive >
                <thead className="text-primary text-left">
                  <th>Message</th>
                  <th>Platform</th>
                  <th>Scheduled</th>
                  <th>Target Screen</th>
                  <th>Type</th>
                  <th>Sent On</th>
                  <th>Status</th>
                  <th>Fail Reason</th>
                  <th>Message Service</th>
                </thead>
                <tbody>{notificationElements}</tbody>

              </Table>
              {totalNotifications > 0 ?
                <div className="pagBox">

                  <div className="pagNo-s">
                    <b>{firstRecord} - {lastRecord} of {totalNotifications}</b>
                  </div>
                  <div className="pagDgt-s">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={records}
                      totalItemsCount={totalNotifications}
                      pageRangeDisplayed={3}
                      onChange={handlePageChange.bind(this)}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                </div>
                : ''}
            </CardBody>
            {/* <CardFooter> </CardFooter> */}
          </Card>
        </Col>
      </Row>
      <Modal isOpen={showRescheduleModal} toggle={() => setShowRescheduleModal(false)}>
        <ModalHeader>Reschedule Notification</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>New Schedule Time <span className="text-danger">*</span></Label>
            <ReactDatetime
              isValidDate={disablePastDates}
              onChange={(val) => setRescheduleTime(val)}
              value={rescheduleTime}
              dateFormat="DD/MM/YYYY"
            />
            {rescheduleError && <p style={{ color: 'red', marginTop: '8px' }}>{rescheduleError}</p>}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          {rescheduleLoader ? (
            <Spinner size="sm" />
          ) : (
            <>
              <Button color="primary" onClick={handleRescheduleConfirm}>Confirm</Button>
              <Button color="secondary" onClick={() => setShowRescheduleModal(false)}>Cancel</Button>
            </>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );


}

export default List;
